import * as Yup from 'yup';

export const nameAndImage = Yup.object({
  name: Yup.string().required(),
  imageType: Yup.string().optional(),
  customImageData: Yup.string().optional(),
});
